/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Tenant
 */
export interface Tenant {
  /**
   *
   * @type {string}
   * @memberof Tenant
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof Tenant
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof Tenant
   */
  defaultStarvation?: number;
  /**
   *
   * @type {number}
   * @memberof Tenant
   */
  defaultMaxStarvationDays?: number;
  /**
   *
   * @type {number}
   * @memberof Tenant
   */
  defaultHarvestLossSalmon?: number;
  /**
   *
   * @type {number}
   * @memberof Tenant
   */
  defaultHarvestLossTrout?: number;
  /**
   *
   * @type {number}
   * @memberof Tenant
   */
  defaultStarvationLossRateSalmon?: number;
  /**
   *
   * @type {number}
   * @memberof Tenant
   */
  defaultStarvationLossRateTrout?: number;
  /**
   *
   * @type {string}
   * @memberof Tenant
   */
  defaultMortalityModelTemplateId?: string;
  /**
   *
   * @type {string}
   * @memberof Tenant
   */
  defaultSalesPriceModelTemplateId?: string;
  /**
   *
   * @type {string}
   * @memberof Tenant
   */
  defaultQualityGradingModelTemplateId?: string;
  /**
   *
   * @type {string}
   * @memberof Tenant
   */
  shortTermGrowthModelType?: TenantShortTermGrowthModelTypeEnum;
  /**
   *
   * @type {boolean}
   * @memberof Tenant
   */
  hasITTT?: boolean;
}

export const TenantShortTermGrowthModelTypeEnum = {
  SimpleEwma: 'simple_ewma',
  DynamicEwma: 'dynamic_ewma',
  NgrResidualEts: 'ngr_residual_ets',
} as const;

export type TenantShortTermGrowthModelTypeEnum =
  (typeof TenantShortTermGrowthModelTypeEnum)[keyof typeof TenantShortTermGrowthModelTypeEnum];
